// Language Constants
export const LANGUAGES = {
    en: 'English',
    ar: 'Arabic',
}

export const AGE_GROUPS = {
    ADL: 'Adult',
    CHD: 'Child',
    INF: 'Infant',
    SNR: 'Senior',
}

export const SEAT_TYPES = {
    STD: 'Standard',
    VIP: 'VIP',
}

export const DAYS_OF_WEEK = [
    { code: 'sun', label: 'Sunday' },
    { code: 'mon', label: 'Monday' },
    { code: 'tue', label: 'Tuesday' },
    { code: 'wed', label: 'Wednesday' },
    { code: 'thu', label: 'Thursday' },
    { code: 'fri', label: 'Friday' },
    { code: 'sat', label: 'Saturday' },
]
